<template>
  <div class="lad-landing-whats-included__custom">
    <div class="cities">
      <p class="subtitle">{{ $t(`${base}.cities`) }}</p>

      <div class="cities-content">
        <div
          v-for="(destination, i) in exDestinations"
          :key="`whats-included-destination-${i}`"
          class="item"
        >
          <i class="el-icon-circle-check" />

          <p>{{ destination }}</p>
        </div>
      </div>
    </div>
    <div class="content">
      <p class="subtitle">{{ $t(`${base}.included`) }}</p>
      <div class="included">
        <div
          v-for="(item, i) in included"
          :key="`whats-included-destination-${i}`"
          class="item"
        >
          <i class="el-icon-circle-check" />

          <p>{{ item.title }}</p>
        </div>
      </div>
      <div class="not-included">
        <p class="subtitle">{{ $t(`${base}.not_included`) }}</p>

        <div
          v-for="(item, i) in notIncluded"
          :key="`whats-included-destination-${i}`"
          class="item"
        >
          <i class="el-icon-circle-close" />

          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CacheComponentMixin from '@/utils/mixin/cache-components'

export default {
  name: 'LadLandingWhatsIncludedCustom',
  mixins: [CacheComponentMixin],
  data() {
    return {
      base: 'landing.whats_included',
    }
  },
  computed: {
    ...mapState('experience', {
      exWhatsIncluded: (state) => state.whats_included,
      exDestinations: (state) => state.experience.destinations || [],
    }),
    ...mapGetters('device', ['isMobile']),
    included() {
      return this.exWhatsIncluded.filter((t) => t.included)
    },
    notIncluded() {
      return this.exWhatsIncluded.filter((t) => !t.included)
    },
  },
}
</script>

<style lang="scss">
.lad-landing-whats-included {
  &__custom {
    background-color: #fff;

    .cities {
      gap: 6px;
      display: grid;
      padding: 8px 20px 32px;

      &-content {
        gap: 6px;
        display: grid;
        grid-template-columns: 1fr 1fr;

        @media (min-width: 768px) {
          grid-template-columns: 1fr 1fr 1fr 1fr;
        }
      }
    }

    .subtitle {
      font-size: 14px;
      font-weight: 700;
      line-height: 21px;
      color: #1d1d1d;
      margin: 0;
    }

    .item {
      gap: 8px;
      display: grid;
      align-items: center;
      grid-template-columns: 16px 1fr;

      i {
        &.el-icon-circle {
          &-check {
            color: #0a960c;
          }

          &-close {
            color: #f56c6c;
          }
        }
      }

      p {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        line-height: 23.36px;
        color: #1d1d1d;
      }
    }

    .content {
      gap: 24px;
      display: grid;
      padding: 8px 20px 16px;

      .subtitle {
        font-size: 20px;
        font-weight: 700;
        line-height: 30px;
        color: #1d1d1d;
        margin: 0;
      }

      .included,
      .not-included {
        gap: 8px;
        display: grid;
        height: max-content;

        .item {
          p {
            margin: 0;
            font-size: 16px;
            font-weight: 700;
            line-height: 23.36px;
            color: #000;
          }
        }
      }
      .included {
        @media (min-width: 768px) {
          grid-template-columns: 1fr 1fr;
        }
      }
    }
  }
}
</style>
